var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRsvpSidebarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.89543 16 2V10C16 11.1046 15.1046 12 14 12H2C0.895431 12 0 11.1046 0 10V2ZM2 1C1.44772 1 1 1.44772 1 2V2.2169L4.2347 4.15772C4.09269 4.47863 4.01419 4.82381 4.00168 5.18411L1 3.3831V9.10522L4.45256 6.98056C4.59907 7.25791 4.78174 7.53677 5.00221 7.8165L1.03376 10.2586C1.14774 10.6855 1.53715 11 2 11H14C14.4628 11 14.8523 10.6855 14.9662 10.2586L10.9978 7.81651C11.2183 7.53679 11.4009 7.25793 11.5475 6.98058L15 9.10522V3.3831L11.9983 5.18409C11.9858 4.82379 11.9073 4.47862 11.7653 4.15771L15 2.2169V2C15 1.44772 14.5523 1 14 1H2ZM8 3.99275C9.66439 2.282 13.8254 5.27581 8 9.125C2.17465 5.27581 6.33561 2.282 8 3.99275Z",
    fill: "#A0AEC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvpSidebarIcon);
export default __webpack_public_path__ + "static/media/rsvp_sidebar_icon.79083972553fc54bcc0dd52c8426a619.svg";
export { ForwardRef as ReactComponent };